// var models = require.context(
// 	'../models', //context folder
// 	true, // include subdirectories
// 	/.*/ //#RegExp
// );
// var components = require.context(
// 	'../components', //context folder
// 	true, // include subdirectories
// 	/.*/ //#RegExp
// );

/* global __webpack_require__ */
import { guardChunkLoading } from 'imports/staleChunkReload';

guardChunkLoading(__webpack_require__, {
	getStorage: () => window.sessionStorage,
	reload: () => window.location.reload(),
});

import './lodashEntry';

require('components/Dashboard');

import { CacheableDataObject } from 'models/CacheableDataObject';

require('app/common-scripts.jsx');
require('addons/date-format.jsx');
require('addons/jquery.serializejson.jsx');

require('app/matchmaking.jsx');